import log from 'salvo-lite/log'

class MobileChangeClass {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = JSON.parse(elem.getAttribute('data-mobile-class'))

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const _this = this

        window.addEventListener('resize', function () {
            _this.changeClass(_this)
        })
        _this.changeClass(_this)
    }

    changeClass (component) {
        const _this = component

        if (window.innerWidth < _this._options.breakpoint) {
            _this._elem.classList.add(_this._options.mobileClass)
            _this._elem.classList.remove(_this._options.desktopClass)
        } else {
            _this._elem.classList.add(_this._options.desktopClass)
            _this._elem.classList.remove(_this._options.mobileClass)
        }
    }
}

export default MobileChangeClass



// WEBPACK FOOTER //
// ./src/resources/scripts/components/MobileChangeClass.js